<template>
  <div class="loading-bar">
    <self-building-square-spinner
    class="loading-element"
    :animation-duration="4000"
    :size="60"
    color="#488c4e"
    />
  </div>
</template>

<script>
import { SelfBuildingSquareSpinner } from 'epic-spinners'

export default {
  name: 'Loading',
  components: {
    SelfBuildingSquareSpinner
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>